import SoftooMap from "../Map";
import Map from "ol/Map";
import Translate from "ol/interaction/Translate";
import Feature from "ol/Feature";

export class TranslateFeature extends Translate {
  private $map: SoftooMap;
  private original: Feature;
  constructor(options) {
    let afterMoved;
    options = options || {}
    if (options.afterMoved) {
      afterMoved = options.afterMoved;
      delete options.afterMoved;
    }
    if (options.features) {
      //only support to move one feature at a time.
      //the to be moved feature is selected via clicking at it
      delete options.features;
    }
    super(options);
    if (afterMoved) {
      this.afterMoved = afterMoved;
    }
    this.on('translatestart',this.start);
    this.on('translateend',this.end);
  }

  start(event) {
    if (!!event.features) {
      this.original = this.$map.cloneFeature(
        event.features.item(0)
      );
    }
  }

  end(event) {
    if (!!event.features) {
      this.$map.addUndo(this.original, 'Update');
      let moved = event.features.item(0);
      moved.set('STATE', 'Update');
      this.afterMoved({
        original: this.original,
        modified: moved
      });
    }
    this.original = null;
  }
  
  afterMoved(event) {
    // to be override by application
  }

  setMap(map:Map) {
    if (map) {
      this.$map = map['SOFTOO_MAP'];
    }
    super.setMap(map);
  }

  remove() {
    this.un('translatestart',this.start);
    this.un('translateend',this.end);
    this.getMap().removeInteraction(this);
  }
}